import React from 'react';
import { TextMediumdS, TextMediumXS } from '../../../../Components/Text/MediumText';
import NuDate from '../../../../Components/Utils/NuDate';
import UseGetDashBoardData from '../../../../Components/Hooks/useDashboardData';

const dummyData = [
  {
    invoiceref: 'INV-1001',
    client: 'Acme Corp',
    amount: '$5,200',
    dueDate: '2024-02-10',
    daysElapsed: 61,
  },
  {
    invoiceref: 'INV-1002',
    client: 'Beta Ltd',
    amount: '$3,800',
    dueDate: '2024-02-28',
    daysElapsed: 43,
  },
  {
    invoiceref: 'INV-1003',
    client: 'Gamma Pvt',
    amount: '$1,900',
    dueDate: '2024-03-10',
    daysElapsed: 33,
  },
  {
    invoiceref: 'INV-1004',
    client: 'Delta Inc',
    amount: '$2,250',
    dueDate: '2024-03-25',
    daysElapsed: 18,
  },
];

function InvoiceDue() {
  // const data = dummyData;
  const { data, loading } = UseGetDashBoardData(`/dashboard/invoice-outgoing/due-report`);

  return (
    <div className="col-span-2 bg-white h-[50vh] 2xl:h-[54vh] w-full p-4 rounded-2xl shadow-lg  flex flex-col">
      <div className="flex items-center justify-between mb-1">
        <h2 className="text-sm  font-bold text-gray-800">
          Invoice In Due
        </h2>
        <span className="bg-red-100 text-red-600 text-xs font-medium px-2 py-0.5 rounded-lg">
          Total : {data?.length || 0}
        </span>
      </div>
      <p className="text-gray-500 text-xs font-light mb-3">Due Since 30 days and more</p>

      <div className=" w-full h-[96%] overflow-y-scroll pb-4">
        <table className="w-full text-sm">
          <thead className="sticky top-0 z-10 bg-white shadow-sm">
            <tr className="text-gray-700 border-b">
              <th className="text-left px-2 py-2"><TextMediumXS content="Invoice No." /></th>
              {/* <th className="text-left px-2 py-2"><TextMediumXS content="Client" /></th> */}
              <th className="text-left px-2 py-2"><TextMediumXS content="Amount" /></th>
              <th className="text-left px-2 py-2"><TextMediumXS content="Due Date" /></th>
              <th className="text-left px-2 py-2"><TextMediumXS content="Days Elapsed" /></th>
            </tr>
          </thead>
          <tbody>
            {data && data?.map((item, index) => (
              <tr
                className={`${
                  index % 2 === 0 ? 'bg-slate-50' : 'bg-white'
                } border-b hover:bg-slate-100 transition-all`}
                key={index}
              >
                <td className="px-2 py-2">
                  <TextMediumdS content={item?.invoiceNo || "N/A"} />
                </td>
                {/* <td className="px-2 py-2">
                  <TextMediumdS content={item?.client || "N/A"} />
                </td> */}
                <td className="px-2 py-2">
                  <TextMediumdS content={item?.amount || "N/A"} />
                </td>
                <td className="px-2 py-2">
                <TextMediumdS content={item?.dueDate ? (
    <NuDate value={item.dueDate} format="DD MMM YYYY" />
  ) : (
    "N/A"
  )} />
                </td>
                <td className="px-2 py-2">
                <TextMediumdS
  content={
    <span
      className={`flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-lg ${
        item?.daysElapsed >= 30
          ? ' text-red-700'
          : ' text-gray-700'
      }`}
    >
      ⏱️ {item?.daysElapsed || 0} 
    </span>
  }
/>

                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default InvoiceDue;
